import React, { useEffect } from "react";
import { motion } from "framer-motion";

type DataProps = {
	children: any;
	toggleModal: Function;
	showModal: boolean;
	tittle: string;
};
const Modal: React.FC<DataProps> = (props) => {
	const toggleModal = () => {
		props.toggleModal();
		if (typeof document !== "undefined")
			document.body.classList.remove("overflow-hidden");
		// window.history.go(-1);
	};

	useEffect(() => {
		// props.showModal &&
		// 	window.history.pushState({}, "", "?" + props.location);
	});
	if (typeof document !== "undefined")
		props.showModal
			? document.body.classList.add("overflow-hidden")
			: document.body.classList.remove("overflow-hidden");

	document.onkeydown = function (evt: any) {
		evt = evt || window.event;
		var isEscape = false;
		if ("key" in evt) {
			isEscape = evt.key === "Escape" || evt.key === "Esc";
		} else {
			isEscape = evt.keyCode === 27;
		}
		if (isEscape) {
			toggleModal();
		}
	};
	// window.onpopstate = function (e) {
	// 	console.log(window.location.hash);
	// 	if (window.location.hash == "") toggleModal();
	// 	console.log(e);
	// };
	// window.onbeforeunload = function () {
	// 	toggleModal();
	// 	console.log("tttttt");
	// 	location.hash = "";
	// };
	if (!props.showModal) return <></>;
	return (
		<div
			className={`modal ${
				props.showModal ? "block" : "hidden"
			} z-50 fixed w-full h-full top-0 left-0  max-h-screen flex items-center justify-center`}
		>
			<div className='modal-overlay absolute w-full h-full bg-gray-900 opacity-50'></div>

			<motion.div
				animate={{ scale: 1, opacity: 1 }}
				initial={{ scale: 0.5, opacity: 0 }}
				transition={{
					duration: 0.2,
				}}
				className='modal-container mt-5 max-h-screen  bg-white w-11/12 md:max-w-3xl mx-auto border-black border-2 shadow-lg z-50 overflow-y-auto'
			>
				{/* <div
					onClick={() => {
						toggleModal();
					}}
					className='modal-close mb-4  absolute top-0 right-0 cursor-pointer flex flex-col items-center mt-4 mr-4 text-white text-sm z-50'
				>
					<svg
						className='fill-current text-white'
						xmlns='http://www.w3.org/2000/svg'
						width='18'
						height='18'
						viewBox='0 0 18 18'
					>
						<path d='M14.53 4.53l-1.06-1.06L9 7.94 4.53 3.47 3.47 4.53 7.94 9l-4.47 4.47 1.06 1.06L9 10.06l4.47 4.47 1.06-1.06L10.06 9z'></path>
					</svg>
					<span className='text-sm'>(Esc)</span>
				</div> */}

				<div className='modal-content py-4 text-left px-6'>
					<div className='flex justify-between items-center pb-3'>
						<p className='text-3xl font-bold'>{props.tittle}</p>
						<div
							onClick={() => {
								toggleModal();
							}}
							className='modal-close cursor-pointer z-50'
						>
							<svg
								className='fill-current text-black m-2'
								xmlns='http://www.w3.org/2000/svg'
								width='18'
								height='18'
								viewBox='0 0 18 18'
							>
								<path d='M14.53 4.53l-1.06-1.06L9 7.94 4.53 3.47 3.47 4.53 7.94 9l-4.47 4.47 1.06 1.06L9 10.06l4.47 4.47 1.06-1.06L10.06 9z'></path>
							</svg>
						</div>
					</div>

					{props.children}
				</div>
			</motion.div>
		</div>
	);
};

export default Modal;
